import { render } from "./lookbook-product-list-modal.vue?vue&type=template&id=fa9de954"
import script from "./lookbook-product-list-modal.vue?vue&type=script&lang=js"
export * from "./lookbook-product-list-modal.vue?vue&type=script&lang=js"

import "./lookbook-product-list-modal.vue?vue&type=style&index=0&id=fa9de954&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__